export default __webpack_public_path__ + "static/media/loginBanner.e6de4327.svg";